import React from "react";
import { TEAM, ASSIGNED_TERRITORIES, TEAM_LICENSES, OFFICES } from "../../consts/tables";
import TeamMemberInfo from "./TeamMemberInfo";
import TeamMemberTerritoryInfo from "./TeamMemberTerritoryInfo";
import TeamMemberUploadDocInfo from "./TeamMemberUploadDocInfo";
import { browserHistory } from "react-router";
import CRUD from "../CRUD/CRUD";
import Drawer from "../Drawer";
import { getData, manageData } from "../../requests/CRUD";
import request from 'arcdynamic-request';
import order from './order';
import {executeQuery} from "../../requests/executeQuery";
import { executeBackendQuery } from "../../requests/executeBackendQuery";
import {STRIVE_AGENT_FIRST_LISTING,STRIVE_AGENT_PIPELINE_DETAILS,HSC_MEMBER_LISTING_CLOSING_DATES, TERRITORY_MASTER, AGENT_TERRITORY_MAPPED_DATA, TERRITORY_AGENT_MAPING, GET_ASSIGNED_TERRITORIES_FOR_TEAM_MEMBER, GET_TEAM_LICENSES} from '../../consts/queries';
import { calculateYearsAndMonths ,calculateNextBussinessDay, convertDateFormat,convertDateFormatYYYYMMDD, formattedDate,getCompanyName,checkUploadAccess} from "../../utils";
import { getYearsAtSummitDisplay } from "../../utils/teamMemberDerivedFields";
import cloneDeep from "lodash.clonedeep";
import TeamMemberTerritoriesInfo from "./Territories/TeamMemberTerritoriesInfo";
import TeamMemberAccountTab from "./TeamMemberAccountTab";
import { getTeamMemberTabAccess, isFounderOnlyAccount } from "../../access-levels";
import { accessLevelsApi } from "../../requests/accessLevels";
import { getCurrentAccess, can } from "../../access";
import { createTeamMember } from "../../requests/userManagement";

const PAGE_SIZE = 1000;

export default class CRUDTeamMember extends React.Component {
  drawerComponentRef;
  static createOptions({id, status1, status2, isYtd = 0, orderBy}) {
    return {
        param: {
            AGENT_ID: id,
            STATUS_1: status1,
            STATUS_2: status2 ? status2 : 'NOMATCH',
            IS_YTD: isYtd
        },
        order: order(orderBy),
    };
  }
  static createOptionsWithoutOrder({id, orderBy}) {
    return {
        param: {
            AGENT_ID: id
        },        
    };
  } 

  constructor(props) {
    super(props);

    this.photoUploadRef = React.createRef();
    // Synchronous (non-state) double-submit guard — see handleSubmit().
    this._isSaving = false;

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      isExists:false,
      isDisabled:false,
      loggedInUserEmail:null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      showDrawer: false,
      addNewItemType: null,
      resetDrawer: false,
      territoryMasterData:{},
      territoryCombinations:{},
      territories: [
        {
          PRODUCT_TYPE_ID: "",
          MARKET_ID: "",
          TERRITORY_ID: ""
        }
      ],
      // Snapshot of territories as of entering edit mode, so Cancel can discard
      // any added/edited rows (territories live outside `data`/`original`).
      originalTerritories: [],
      teamLicenseRowId: "",
      fileUploadInProgress: false,
      offices: [],
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handleChangeFile = this.handleChangeFile.bind(this);
    this.saveData = this.saveData.bind(this);
    this.addNewItem = this.addNewItem.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.addNewTerritory = this.addNewTerritory.bind(this);
    this.cancelTerritories = this.cancelTerritories.bind(this);
    this.refreshData = this.refreshData.bind(this);
  }

  async fetchAllPages(fetchPage) {
    let offset = 0;
    let hasMore = true;
    const rows = [];

    while (hasMore) {
      const res = await fetchPage(offset);

      if (!res || res.success === false || !Array.isArray(res.data)) {
        const message = res && res.message ? res.message : "Failed to fetch paged data";
        throw new Error(message);
      }

      rows.push(...res.data);
      hasMore = res.data.length === PAGE_SIZE;
      offset += PAGE_SIZE;
    }

    return rows;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {    
    this.setState({loggedInUserEmail: this.props.userData.email});
    if (this.props.params.id === undefined) {    
      // For new team members, allow uploads (isDisabled = false)
      // User is creating a new team member, so they should have access
      this.setState({isDisabled: false});    
    }
    this.fetch(this.props.params.id);
    this.fetchTerritoryMasterData();
    this.fetchMemberTerritories(this.props.params.id);
    this.fetchOffices();
    accessLevelsApi.options()
      .then((options) => this.setState({ accessLevelOptions: options }))
      .catch(() => this.setState({ accessLevelOptions: [] }));
  }

  fetchOffices() {
    const options = {
      limit: { count: 500, offset: 0 },
      filter: [
        { code: 'DELETED', text: '', type: 'null' },
        { code: 'DELETED', text: '0', type: 'exact' },
      ],
      filterType: 'or',
    };
    getData({ tableCode: OFFICES, options })
      .then((res) => {
        if (res && res.data && Array.isArray(res.data)) {
          const list = res.data
            .filter((row) => row.DELETED !== 1 && row.DELETED !== '1')
            .map((row) => ({
              ...row,
              OFFICE_LABEL: row.NAME || `${row.ADDRESS} ${row.CITY}, ${row.STATE} ${row.ZIP}`,
            }));
          this.setState({ offices: list });
        }
      })
      .catch(() => this.setState({ offices: [] }));
  }

  async fetchTerritoryMasterData(){
    const column= [
      'ARCIMEDES_ROW_ID',
      'MARKET',
      'PRODUCT_TYPE',
      'TERRITORY'
    ];

    /* 
    INFO:
    Instead of hard-coding 1000-row calls, page through until the API returns less than PAGE_SIZE.
    This still builds the hash used for quick lookups, but avoids brittle, duplicated calls.
    */
    try {
      const data = await this.fetchAllPages((offset) =>
        getData({
          tableCode: TERRITORY_MASTER,
          options: { column, limit:{count: PAGE_SIZE, offset} }
        })
      );

      let territoryMasterData = {};
      data.forEach((val)=>{
        let key = val['MARKET']+'#'+val['PRODUCT_TYPE']+'#'+val['TERRITORY'];
        territoryMasterData = {...territoryMasterData,[key]:{...territoryMasterData[key], [val['ARCIMEDES_ROW_ID']]:true}};
      });

      this.setState({ territoryMasterData });
    } catch (err) {
      this.setState({ error: err.message || "Failed to load territory master data" });
    }
  }

  //Here we get member territories and we format the response in needed format
  async fetchMemberTerritories(id){
    try{
      const res = await executeBackendQuery({
        queryName: GET_ASSIGNED_TERRITORIES_FOR_TEAM_MEMBER,
        params: { TEAM_MEMBER_ID: id} 
      })
      if(res.data && res.data.length > 0){
          const territories = res.data.map(item => ({
            ARCIMEDES_ROW_ID: item.ARCIMEDES_ROW_ID,
            PRODUCT_TYPE_ID: item.PRODUCT_TYPE_ID,
            MARKET_ID: item.MARKET_ROW_ID,
            MARKET_NAME: item.MARKET_NAME,
            MARKET_CODE: item.MARKET_CODE,
            TERRITORY_ID: item.TERRITORY_ID,
            TERRITORY_CODE: item.TERRITORY_CODE,
            ZIP: item.TERRITORY_ZIP,
            CITY: item.TERRITORY_CITY,
            COUNTY: item.TERRITORY_COUNTY,
            NAME: item.TERRITORY_NAME,
            TEAM_MEMBER_ID: item.TEAM_MEMBER_ID,
            isExisting: true
          }));
          this.setState({ territories, originalTerritories: territories.map(t => ({ ...t })) });
      }
    } catch (err) {
      this.setState({ error: err.message || "Failed to load territories" });
    }
  }

  //Here we fetch Real Estate Lisence
  async fetchRealEstateLicense(id){
    if (id === undefined || id === null || id === '') return;
    try {
      // Activate the TEAM_ID where-slot (CW1). Without filter.where the backend
      // applies no WHERE and returns *every* team member's license, so res.data[0]
      // would be the same first row for everyone (Claritask: license shown for all).
      const res = await executeBackendQuery({
        queryName: GET_TEAM_LICENSES,
        options: {
          filter: { where: ['CW1'] },
          param: { TEAM_ID: id },
        },
      })
      // A member with no license row must clear any license carried over from the
      // previously viewed member — otherwise the stale filename shows and, worse,
      // a save would update the previous member's row via teamLicenseRowId.
      const license = res && res.data && res.data[0] ? res.data[0] : null;
      this.setState(prevState => ({
        teamLicenseRowId: license ? license.ARCIMEDES_ROW_ID : "",
        data: {
          ...prevState.data,
          REAL_ESTATE_LICENSE_FORM: license ? license.REAL_ESTATE_LICENSE_FORM : ""
        },
        // Keep the license in `original` too, so cancelling an edit (which
        // resets data -> original) restores the filename instead of clearing it.
        original: {
          ...(prevState.original || {}),
          REAL_ESTATE_LICENSE_FORM: license ? license.REAL_ESTATE_LICENSE_FORM : ""
        }
      }));
    } catch (err) {
      this.setState({ error: err.message || "Failed to get Real Estate License" });
    }
  }

  closeDrawer() {
    this.setState({ showDrawer: false, resetDrawer:true});
  }

  async fetchTerritory(data){
        /*
        INFO:
        Retriving the stored values from mapping table and supplied to dropdown and created the HASH(territoryCombinations)
        with list ARCIMEDES_ROW_ID, we can use this id's and HASH keys while soft deleting the rows and also to weather to update or not.
        --------------------
        */
       let currentTeamMember = data?data:this.state.data;
       try {
        const territoryData = await this.fetchAllPages((offset) =>
          executeBackendQuery({
            queryName: AGENT_TERRITORY_MAPPED_DATA,
            params: { AGENT_ID: this.props.params.id, limit: PAGE_SIZE, offset }
          })
        );

        let territoryCombinations = {};
        const markets = new Set();
        const types = new Set();
        const territorys = new Set();

        if (territoryData && territoryData.length) {
          territoryData.forEach((val)=>{
            markets.add(val.MARKET);
            types.add(val.PRODUCT_TYPE);
            territorys.add(val.TERRITORY);
            let key = val.MARKET+'#'+val.PRODUCT_TYPE+'#'+val.TERRITORY;
            if(key in territoryCombinations){
              territoryCombinations={
                ...territoryCombinations,
                [key]:[...territoryCombinations[key],val.ARCIMEDES_ROW_ID]
              };
            }else{
              let temp = [val.ARCIMEDES_ROW_ID];
              territoryCombinations={
                ...territoryCombinations,
                [key]: temp
              };
            }
          });
        }
        let market = '';
        let type = '';
        let territory = '';

        markets.forEach((key)=>{market = market+','+key;});
        types.forEach((key)=>{type = type+','+key;});
        territorys.forEach((key)=>{territory = territory+','+key;});

        currentTeamMember['MARKET'] = market;
        currentTeamMember['TYPE'] = type;
        currentTeamMember['TERRITORY'] = territory;

        /* ---------------------------------------- */

        this.setState({          
          data: currentTeamMember,
          original: { ...currentTeamMember },
          territoryCombinations,
        });
       } catch (err) {
        this.setState({ error: err.message || "Failed to load territory data" });
       }
  }
  fetch(id) {
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    if (id === undefined) {
      let data = {};
      data["IS_AGENT"] = 'e'; // Default to Summit - Employee (changed from 'summit_employee')
      data["DELETED"] = 'n';
      this.setState({ data: data });
      return;
    }

    getData({
      tableCode: TEAM,
      options: {
        filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
        ],
      },
    }).then(async (res) => {
      if (res && res.success && Array.isArray(res.data) && res.data.length) {
        let currentTeamMember = this.updateDateField(res.data[0]);
        // Everyone's Forms (team.forms = all), or the member's own.
        let isDisabled = checkUploadAccess(this.state.loggedInUserEmail, currentTeamMember.EMAIL, can('team.forms', 'all'));
        this.setState({isDisabled: isDisabled});  
        await this.fetchTerritory(currentTeamMember)
        this.setState({          
          data: currentTeamMember,
          original: { ...currentTeamMember },
          error: null,
      })
      } else {
        this.setState({
          data: false,
          error: res.message ? res.message : "Unidentified Error",
        });
      }
    }).then(() => {
        this.fetchRealEstateLicense(this.props.params.id)
    });
  }
  updateDateField(obj) {    
    obj['STARTING_DATE'] = obj['STARTING_DATE']? formattedDate(obj['STARTING_DATE']) :'';
    obj['BIRTH_DATE'] = obj['BIRTH_DATE']? formattedDate(obj['BIRTH_DATE']) :'';
    obj['ON_PHONES'] = obj['ON_PHONES']? formattedDate(obj['ON_PHONES']) :'';
    obj['IN_POOL'] = obj['IN_POOL']? formattedDate(obj['IN_POOL']) :'';
    obj['FIRST_LISTING'] = obj['FIRST_LISTING']? formattedDate(obj['FIRST_LISTING']) :'';
    obj['FIRST_CLOSING'] = obj['FIRST_CLOSING']? formattedDate(obj['FIRST_CLOSING']) :'';
    obj['TERMINATION_DATE'] = obj['TERMINATION_DATE']? formattedDate(obj['TERMINATION_DATE']) :'';

    // Display order 999 means "no order" in DB; show as empty in UI
    if (obj['ORDER'] == 999 || obj['ORDER'] === '999') {
      obj['ORDER'] = '';
    }

    return obj;   
  }

  async checkDuplicateTeamMember() {
    const { data } = this.state;

    if (!data || !data.FIRST_NAME || !data.LAST_NAME || !data.CELL_PHONE) {
      return false;
    }

    try {
      const options = {
        column: [
          'ARCIMEDES_ROW_ID',
          'FIRST_NAME',
          'LAST_NAME',
          'CELL_PHONE',
        ],
        filterType: 'and',
        filter: [
          { text: data.FIRST_NAME, code: 'FIRST_NAME', type: 'exact' },
          { text: data.LAST_NAME, code: 'LAST_NAME', type: 'exact' },
          { text: data.CELL_PHONE, code: 'CELL_PHONE', type: 'exact' },
        ],
        limit: { count: 5, offset: 0 },
      };

      const res = await getData({ tableCode: TEAM, options });

      if (res && res.success && Array.isArray(res.data)) {
        const duplicate = res.data.find(
          (u) => u.ARCIMEDES_ROW_ID !== data.ARCIMEDES_ROW_ID
        );

        return Boolean(duplicate);
      }
    } catch (err) {
      this.setState({ error: err.message || "Failed to check duplicate team member" });
    }

    return false;
  }
  async handleSubmit(e) {
    e.preventDefault();
  
    if (this.state.viewMode) this.setState((prev) => ({ viewMode: false, originalTerritories: prev.territories.map(t => ({ ...t })) }));
      
    if(this.state.viewMode)
    {
      this.updateUserData(this.state.data.ARCIMEDES_ROW_ID);
    }      

    if (
      this.state.data.FIRST_NAME === undefined ||
      this.state.data.FIRST_NAME === "" ||
      this.state.data.LAST_NAME === undefined ||
      this.state.data.LAST_NAME === ""
    ) {
      this.setState({ errorTabs: [0], success: null });
      return;
    } else {
      this.setState({ errorTabs: [] });
    }

    if (this.state.isBusy || this.state.viewMode === true) return;

    // Synchronous guard: `isBusy` lives in React state, which doesn't flush
    // until the next render, so a fast double-submit (double-click, double
    // Enter) can pass the check above twice before saveData() ever sets
    // isBusy — racing two saveData() calls. The second run's date conversion
    // then sees dates saveData() already converted to YYYY-MM-DD, fails to
    // re-convert them, and silently saves '' — wiping whichever of Start
    // Date/Birth Date/Termination Date it lands on (Claritask: team member
    // dates cleared after saving a termination date).
    if (this._isSaving) return;
    this._isSaving = true;

    const isDuplicate = await this.checkDuplicateTeamMember();
    if (isDuplicate) {
      this._isSaving = false;
      this.setState({ isExists: true, success: null });
      return;
    }

    this.setState({ isExists: false });

    this.setState({ viewMode: true }, () => this.saveData());

  }
  async assignTerritores(rowId){
      // Only a Product Type is required. A row with just a product type (no market
      // and/or territory) still saves; a completely empty row (no product type) is
      // dropped. Market/Territory are optional and stored as NULL when not chosen.
      const validTerritories = [...this.state.territories].filter(
        item => item.PRODUCT_TYPE_ID
      );

      // Remove the empty (no product type) rows from the UI too, so they don't linger.
      if (validTerritories.length !== this.state.territories.length) {
        this.setState({ territories: validTerritories.map(t => ({ ...t })) });
      }

      // Soft-delete existing rows the user removed during this edit: present in the
      // snapshot taken on entering edit mode, but no longer in the current list.
      const keptIds = new Set(
        this.state.territories.map(t => t.ARCIMEDES_ROW_ID).filter(Boolean).map(String)
      );
      const removed = (this.state.originalTerritories || []).filter(
        t => t.ARCIMEDES_ROW_ID && !keptIds.has(String(t.ARCIMEDES_ROW_ID))
      );
      for (const r of removed) {
        try {
          await manageData({ tableCode: ASSIGNED_TERRITORIES, data: [{ ARCIMEDES_ROW_ID: r.ARCIMEDES_ROW_ID, DELETED: 1 }] });
        } catch (e) { /* ignore individual delete failure */ }
      }

      // Nothing new to upsert — the removals above are already handled.
      if (!validTerritories.length) return;

      let dataArray = validTerritories.map(item => {
        return(
          {
            PRODUCT_TYPE_ID: item.PRODUCT_TYPE_ID,
            MARKET_ID: item.MARKET_ID || null,
            TERRITORY_ID: item.TERRITORY_ID || null,
            TEAM_MEMBER_ID: rowId,
            ...(item.ARCIMEDES_ROW_ID && { ARCIMEDES_ROW_ID: item.ARCIMEDES_ROW_ID })
          }
        )
      })
      try{
        let res = await manageData({
            tableCode: ASSIGNED_TERRITORIES,
            data: dataArray
        })
        if(res.data && res.data.length > 0){
          const territories = res.data.map(item => ({
            ARCIMEDES_ROW_ID: item.ARCIMEDES_ROW_ID,
            PRODUCT_TYPE_ID: item.PRODUCT_TYPE_ID,
            MARKET_ID: item.MARKET_ID,
            TERRITORY_ID: item.TERRITORY_ID,
            TEAM_MEMBER_ID: item.TEAM_MEMBER_ID,
          }));
          this.setState({ territories });
      }
      } catch(err){
          this.setState({ error: "Failed to add territories" });
      }
  }
  async assignRealEstateLicense(id){
      let data = {
        TEAM_ID: id,
        REAL_ESTATE_LICENSE_FORM: this.state.data.REAL_ESTATE_LICENSE_FORM
      }
      if(this.state.teamLicenseRowId){
        data.ARCIMEDES_ROW_ID = this.state.teamLicenseRowId
      }
      if(!this.state.teamLicenseRowId && !this.state.data.REAL_ESTATE_LICENSE_FORM) return;
      try{
        let res = await manageData({
            tableCode: TEAM_LICENSES,
            data: [data]
        })
        if(res && res.data && res.data[0]){
          this.setState(prevState => ({...prevState, teamLicenseRowId: res.data[0].ARCIMEDES_ROW_ID}))
        }
      } catch(err){
          this.setState({ error: "Failed to add Real Estate License" });
      }
  }
  
  updateUserData(rowId){    
      const data = {...this.state.data}; 
      data.ON_PHONES = data.STARTING_DATE?calculateNextBussinessDay(new Date(data.STARTING_DATE),90):'';
      data.IN_POOL = data.STARTING_DATE?calculateNextBussinessDay(new Date(data.STARTING_DATE),270):'';
      data.YRS_AT_STRIVE = getYearsAtSummitDisplay(data);
      var BirthdayDifference = data.BIRTH_DATE?calculateYearsAndMonths(new Date(data.BIRTH_DATE)):'';
      data.AGE = BirthdayDifference;      
    

      if(data.IS_AGENT === 'h'){        //Get first closing and first listing date if the team member is hsc team member
        Promise.all([          
          executeQuery({queryName: HSC_MEMBER_LISTING_CLOSING_DATES,  params: { HSC_TEAM_MEMBER_FIRST: data.EMAIL } })
      ]).then(res => { 
        if (res && res[0] && res[0].success && Array.isArray(res[0].data)){       
           data.FIRST_CLOSING = res[0].data[0]?convertDateFormat(res[0].data[0]['LOAN_CLOSING_DATE']):"";
           data.FIRST_LISTING = res[0].data[0]?convertDateFormat(res[0].data[0]['HSC_LISTED_DATE']):"";  
          
           this.setState({
            data:data
          });
        }
      });
    } else {
        const closedHistoricalOptions = CRUDTeamMember.createOptions({
            id: rowId,
            status1: 'Closed',
            orderBy: 'CLOSE_OF_ESCROW.desc'
        });
        const listingOptions = CRUDTeamMember.createOptionsWithoutOrder({
            id: rowId,
            orderBy: 'LISTED_DATE .desc'
        });
        const closedYtdOptions = CRUDTeamMember.createOptions({
          id: rowId,
          status1: 'Closed',
          isYtd: 1,
          orderBy: 'CLOSE_OF_ESCROW.asc'
      });
          const requests = [
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: closedHistoricalOptions}),
            executeQuery({queryName: STRIVE_AGENT_FIRST_LISTING, options: listingOptions}),  
            executeQuery({queryName: STRIVE_AGENT_PIPELINE_DETAILS, options: closedYtdOptions}),     
        ];

        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        if (!agentName) {
          const options = {
            column: [
                'FIRST_NAME',
                'LAST_NAME',
            ],
            filter: [{
                'text': rowId,
                'code': 'ARCIMEDES_ROW_ID',
                'type': 'exact',
            }],
        };
        requests.push(getData({tableCode: TEAM, options}));
      }

      Promise.all(requests).then(res => {
          if (res && res[0] && res[0].success && Array.isArray(res[0].data) && 
              res && res[1] && res[1].success && Array.isArray(res[1].data) &&
              res && res[2] && res[2].success && Array.isArray(res[2].data) ) {
              /* if(res[0] && res[0].data && res[0].data.length > 0){
                const filteredData = res[0].data.filter(item => item.TRANSACTION_TYPE !== "Referral");
                const sortedData = filteredData.sort((a, b) => new Date(a.CLOSE_OF_ESCROW) - new Date(b.CLOSE_OF_ESCROW));
                const firstEscrowDate = sortedData.length > 0 ? sortedData[0].CLOSE_OF_ESCROW : null;
                data.FIRST_CLOSING = res[0].data[0]?convertDateFormat(firstEscrowDate):"";
              } else  if(res[0] && res[0].data && res[0].data.length === 0 && res[2] && res[2].data && res[2].data.length > 0){
               */
              let closedProperties = [];
              if(res[0] && res[0].data && res[0].data.length > 0 && res[2] && res[2].data && res[2].data.length > 0){
                 closedProperties = [...res[0].data,...res[2].data];
              }else if(res[0] && res[0].data && res[0].data.length > 0 && res[2] && res[2].data && res[2].data.length === 0){
                closedProperties = [...res[0].data];
              }else if(res[2] && res[2].data && res[2].data.length > 0 && res[0] && res[0].data && res[0].data.length === 0){
                closedProperties = [...res[2].data];
              }
              if(closedProperties.length > 0){                
                const filteredData = closedProperties.filter(item => item.TRANSACTION_TYPE !== "Referral");
                const result = filteredData.filter(property => {
                  // Check listing agents
                  if (
                      (property.LISTING_AGENT_1 === rowId && parseFloat(property.LISTING_AGENT_1_PERCENT) >= 25) ||
                      (property.LISTING_AGENT_2 === rowId && parseFloat(property.LISTING_AGENT_2_PERCENT) >= 25) ||
                      (property.LISTING_AGENT_3 === rowId && parseFloat(property.LISTING_AGENT_3_PERCENT) >= 25)
                  ) {
                      return true;
                  }
              
                  // Check buyer agents
                  if (
                      (property.BUYER_AGENT_1 === rowId && parseFloat(property.BUYER_AGENT_1_PERCENT) >= 25) ||
                      (property.BUYER_AGENT_2 === rowId && parseFloat(property.BUYER_AGENT_2_PERCENT) >= 25) ||
                      (property.BUYER_AGENT_3 === rowId && parseFloat(property.BUYER_AGENT_3_PERCENT) >= 25)
                  ) {
                      return true;
                  }
              
                  return false;
              }).map(property => property.CLOSE_OF_ESCROW).filter(Boolean);
                const firstClosingDate = result.sort((a, b) => new Date(a) - new Date(b))[0];
                data.FIRST_CLOSING = firstClosingDate?convertDateFormat(firstClosingDate):"";
              }

              if (res[1]) {
                const startDate = new Date(data.STARTING_DATE);
                const firstAfterStartDateObj = res[1].data
                .map(item => ({ ...item, LISTED_DATE: new Date(item.LISTED_DATE) })) 
                .filter(item => item.LISTED_DATE > startDate) 
                .sort((a, b) => a.LISTED_DATE - b.LISTED_DATE) 
                .shift(); 

                data.FIRST_LISTING = firstAfterStartDateObj && firstAfterStartDateObj.LISTED_DATE?convertDateFormat(firstAfterStartDateObj.LISTED_DATE):"";  
              } 
              this.setState({
                data:data
              });
          }
      });
    }  
  }
  handleChangeDropdown(query, queryType, x, key) {
    const data = {...this.state.data}; 
    data[key] = query[key];
    this.setState({
      data:data
    });
}
  handleChangeFile(key, value){
    let data = {...this.state.data};
    data[key] = value;
    this.setState({data: data}, () => {
      // If we're in viewMode (already saved) and PHOTO was just set, auto-save to persist it
      if (this.state.viewMode && key === 'PHOTO' && value && this.state.data.ARCIMEDES_ROW_ID) {
        this.saveData();
      }
    });
  }
  handleChangeInput(key, value) {   
    const data = {...this.state.data};
    
    // HSC auto-detection commented out - no longer creating new HSC users
    // if(key === 'EMAIL'){   
    //   if(getCompanyName(value) === "highstcapital")
    //   {
    //     data.IS_AGENT = "h";
    //   }
    // }
    
    if (key === 'STARTING_DATE') {
      data.ON_PHONES = calculateNextBussinessDay(new Date(value),90);
      data.IN_POOL = calculateNextBussinessDay(new Date(value),270);
    }
    if (key === 'STARTING_DATE' || key === 'TERMINATION_DATE') {
      data.YRS_AT_STRIVE = getYearsAtSummitDisplay({...data, [key]: value});
    }
    if (key === 'BIRTH_DATE') {
      var difference = calculateYearsAndMonths(new Date(value));
      data.AGE = difference;
    }
    data[key] = value;
    this.setState({
      data:data
    });   
  }
  
  /**
   * Create new team member with auth credentials via Laravel REST API.
   * Maps UPPERCASE state fields to lowercase API fields.
   */
  async createNewTeamMemberWithAuth() {
    const data = this.state.data;
    
    // Validate required auth fields
    if (!data.USERNAME) {
      this.setState({
        isBusy: false,
        error: 'Username is required (set in Account Settings tab)',
      });
      return;
    }
    if (!data.PASSWORD) {
      this.setState({
        isBusy: false,
        error: 'Password is required (set in Account Settings tab)',
      });
      return;
    }
    
    // Derived fields: same formulas as TeamMemberInfo / handleChangeInput
    const startingDate = data.STARTING_DATE ? new Date(data.STARTING_DATE) : null;
    const birthDate = data.BIRTH_DATE ? new Date(data.BIRTH_DATE) : null;
    const onPhones = startingDate ? calculateNextBussinessDay(startingDate, 90) : null;
    const inPool = startingDate ? calculateNextBussinessDay(startingDate, 270) : null;
    const yrsAtStrive = getYearsAtSummitDisplay(data) || null;
    const age = birthDate ? calculateYearsAndMonths(birthDate) : null;

    // Prepare payload with lowercase keys for Laravel API
    const payload = {
      // Auth credentials (from Account Settings tab)
      username: data.USERNAME,
      email: data.EMAIL,
      password: data.PASSWORD,
      status_code: data.STATUS_CODE || 'active',
      // The Role dropdown on the Team Member tab owns this field (see roles.js).
      is_agent: data.IS_AGENT || 'e',
      
      // Personal info
      first_name: data.FIRST_NAME || '',
      last_name: data.LAST_NAME || '',
      title: data.TITLE || '',
      phone: data.PHONE || '',
      cell_phone: data.CELL_PHONE || '',
      linkedin: data.LINKEDIN || '',
      description: data.DESCRIPTION || '',
      bio: data.BIO || '',
      photo: data.PHOTO || '',
      credentials: data.CREDENTIALS || '',
      visible_on_website: data.VISIBLE_ON_WEBSITE || null,
      show_in_peak: data.SHOW_IN_PEAK || null,

      // Dates — normalize to YYYY-MM-DD for Laravel date validation
      starting_date: data.STARTING_DATE ? convertDateFormatYYYYMMDD(data.STARTING_DATE) : null,
      termination_date: data.TERMINATION_DATE ? convertDateFormatYYYYMMDD(data.TERMINATION_DATE) : null,
      birth_date: data.BIRTH_DATE ? convertDateFormatYYYYMMDD(data.BIRTH_DATE) : null,
      on_phones: onPhones ? convertDateFormatYYYYMMDD(onPhones) : null,
      in_pool: inPool ? convertDateFormatYYYYMMDD(inPool) : null,
      yrs_at_strive: yrsAtStrive || null,
      age: age || null,
      
      // Address
      address: data.ADDRESS || '',
      city: data.CITY || '',
      state: data.STATE || '',
      zip: data.ZIP || '',
      
      // Relationships
      office_id: data.OFFICE_ID || null,
      
      // Ordering
      order: data.ORDER || 999,
    };
    
    try {
      const res = await createTeamMember(payload);
      
      if (res && res.success && res.data) {
        // Update state with response data (convert lowercase to UPPERCASE)
        const savedData = { ...this.state.data };
        savedData.ARCIMEDES_ROW_ID = res.data.ARCIMEDES_ROW_ID;
        savedData.USERNAME = res.data.USERNAME;
        savedData.EMAIL = res.data.EMAIL;
        savedData.STATUS_CODE = res.data.STATUS_CODE;
        savedData.IS_AGENT = res.data.IS_AGENT;
        
        // Clear password from state (security)
        delete savedData.PASSWORD;
        
        this.setState(
          {
            data: savedData,
            isBusy: false,
            success: 'Team member created successfully',
          },
          () => {
            // Redirect to edit page
            if (!this.props.edit) {
              browserHistory.push({
                pathname: `/teamMember/${res.data.ARCIMEDES_ROW_ID}`,
              });
            }
          }
        );
        
        window.scrollTo(0, 0);
      } else {
        this.setState({
          isBusy: false,
          error: res && res.message ? res.message : 'Failed to create team member',
        });
      }
    } catch (err) {
      this.setState({
        isBusy: false,
        error: err.message || 'Failed to create team member',
      });
    }
  }
  
  /**
   * Refresh data after Account Settings tab updates.
   */
  async refreshData() {
    const rowId = this.state.data && this.state.data.ARCIMEDES_ROW_ID;
    if (!rowId) return;
    
    try {
      const res = await getData({
        tableCode: TEAM,
        options: {
          filter: [
            { code: 'ARCIMEDES_ROW_ID', text: rowId, type: 'exact' },
          ],
          limit: { count: 1, offset: 0 },
        },
      });
      
      if (res && res.success && res.data && res.data[0]) {
        const updatedData = { ...this.state.data, ...res.data[0] };
        this.setState({ data: updatedData });
      }
    } catch (err) {
      console.error('Failed to refresh data:', err);
    }
  }

  /**
   * Clear cached celebration cards when name or photo changes
   * @param {string} teamMemberId - Arc team member row ID
   */
  async clearCelebrationCardsCache(teamMemberId) {
    try {
      const syncToken = arc.config && arc.config.auth && arc.config.auth.token;
      if (!syncToken) {
        console.warn('[TEAM-MEMBER] No sync token available, skipping cache clear');
        return;
      }

      const response = await fetch(`${arc.path.api}/team-members/${teamMemberId}/clear-celebration-cards`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-crm-sync-token': syncToken
        }
      });

      if (!response.ok) {
        throw new Error(`Cache clear failed: ${response.statusText}`);
      }

      const result = await response.json();
      console.log('[TEAM-MEMBER] Celebration cards cache cleared:', result);
    } catch (error) {
      console.error('[TEAM-MEMBER] Error clearing celebration cards cache:', error);
      throw error;
    }
  }

  saveData() {
    if (this.state.isBusy) return;
    // Past this point isBusy (React state) plus the Save button's `disabled`
    // prop guard against re-entry — release the synchronous pre-save lock.
    this._isSaving = false;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });
    
    // NEW USER: Use Laravel REST API for creation with auth credentials
    const isNewUser = !this.state.data.ARCIMEDES_ROW_ID;
    if (isNewUser) {
      return this.createNewTeamMemberWithAuth();
    }
    
    // EXISTING USER: Use standard Arc CRUD
    // Build the outgoing payload from an immutable clone rather than mutating
    // this.state.data in place — the backend nulls out any field sent as ''
    // (empty_strings_to_null), and convertDateFormatYYYYMMDD() only accepts
    // MM/DD/YYYY input. Mutating this.state.data to YYYY-MM-DD here meant a
    // second saveData() call (e.g. a fast double-submit) would re-run the
    // conversion on an already-converted date, throw, and silently send ''
    // for that field — wiping Start Date/Birth Date whenever it happened to
    // land on those fields (Claritask: team member dates cleared after
    // saving a termination date).
    var tempData = cloneDeep(this.state.data);

    // Always recalculate derived fields from start/birth dates so create/view gaps
    // (and members who never had them persisted) stay correct on save.
    if (tempData.STARTING_DATE) {
      const start = new Date(tempData.STARTING_DATE);
      tempData.ON_PHONES = calculateNextBussinessDay(start, 90);
      tempData.IN_POOL = calculateNextBussinessDay(start, 270);
      tempData.YRS_AT_STRIVE = getYearsAtSummitDisplay(tempData);
    }
    if (tempData.BIRTH_DATE) {
      tempData.AGE = calculateYearsAndMonths(new Date(tempData.BIRTH_DATE));
    }

    tempData.STARTING_DATE = tempData.STARTING_DATE ? convertDateFormatYYYYMMDD(tempData.STARTING_DATE) : '';
    tempData.BIRTH_DATE = tempData.BIRTH_DATE ? convertDateFormatYYYYMMDD(tempData.BIRTH_DATE) : '';
    tempData.ON_PHONES = tempData.ON_PHONES ? convertDateFormatYYYYMMDD(tempData.ON_PHONES) : '';
    tempData.IN_POOL = tempData.IN_POOL ? convertDateFormatYYYYMMDD(tempData.IN_POOL) : '';
    tempData.FIRST_LISTING = tempData.FIRST_LISTING ? convertDateFormatYYYYMMDD(tempData.FIRST_LISTING) : '';
    tempData.FIRST_CLOSING = tempData.FIRST_CLOSING ? convertDateFormatYYYYMMDD(tempData.FIRST_CLOSING) : '';
    tempData.TERMINATION_DATE = tempData.TERMINATION_DATE ? convertDateFormatYYYYMMDD(tempData.TERMINATION_DATE) : '';
    delete tempData.MARKET;
    delete tempData.TYPE;
    delete tempData.REAL_ESTATE_LICENSE_FORM;

    // Empty display order is stored as 999 in DB
    if (tempData.ORDER == null || tempData.ORDER === '') {
      tempData.ORDER = 999;
    }

    // Pad display order with leading zero if less than 10 (e.g. 3 -> "03")
    if (tempData.ORDER != null && tempData.ORDER !== '' && tempData.ORDER !== 999) {
      const orderNum = parseInt(tempData.ORDER, 10);
      if (!isNaN(orderNum) && orderNum < 10) {
        tempData.ORDER = '0' + orderNum;
      }
    }

    if (!tempData.DELETED) {
      tempData.DELETED = 'n';
    }

    // Marketing, Partners and Senior Agents see territories but cannot change them.
    if (this.getTabAccess().territories === 'edit') {
      this.assignTerritores(this.state.data.ARCIMEDES_ROW_ID)
    }
    this.assignRealEstateLicense(this.state.data.ARCIMEDES_ROW_ID)

    // For testing added a new table with 2 additional columns TYPE & MARKET original:TEAM changed to TERRITORY_TEAM_MEMBERS_DEV
    return manageData({ tableCode: TEAM, data: [tempData] }).then(
      (res) => {
        const data = {...this.state.data};
        if (res && res.success) {
          // Preserve core identity and all basic fields from response
          if (res.data[0].ARCIMEDES_ROW_ID) {
            data['ARCIMEDES_ROW_ID'] = res.data[0].ARCIMEDES_ROW_ID;
          }
          
          // Preserve IS_AGENT field - critical for role display
          data['IS_AGENT'] = res.data[0].IS_AGENT || this.state.data.IS_AGENT;
          
          // Preserve other basic fields from response
          if (res.data[0].FIRST_NAME) data['FIRST_NAME'] = res.data[0].FIRST_NAME;
          if (res.data[0].LAST_NAME) data['LAST_NAME'] = res.data[0].LAST_NAME;
          if (res.data[0].EMAIL) data['EMAIL'] = res.data[0].EMAIL;
          if (res.data[0].CELL_PHONE) data['CELL_PHONE'] = res.data[0].CELL_PHONE;
          if (res.data[0].PHONE) data['PHONE'] = res.data[0].PHONE;
          if (res.data[0].ADDRESS) data['ADDRESS'] = res.data[0].ADDRESS;
          if (res.data[0].CITY) data['CITY'] = res.data[0].CITY;
          if (res.data[0].STATE) data['STATE'] = res.data[0].STATE;
          if (res.data[0].ZIP) data['ZIP'] = res.data[0].ZIP;
          if (res.data[0].OFFICE_ID != null && res.data[0].OFFICE_ID !== undefined) data['OFFICE_ID'] = res.data[0].OFFICE_ID;
          
          // Format date fields
          data['STARTING_DATE'] =  res.data[0].STARTING_DATE ? formattedDate(res.data[0].STARTING_DATE) :"";
          data['BIRTH_DATE'] =  res.data[0].BIRTH_DATE ? formattedDate(res.data[0].BIRTH_DATE) :"";
          data['ON_PHONES'] =  res.data[0].ON_PHONES ? formattedDate(res.data[0].ON_PHONES) :"";
          data['IN_POOL'] =  res.data[0].IN_POOL ? formattedDate(res.data[0].IN_POOL) :"";
          data['FIRST_LISTING'] =  res.data[0].FIRST_LISTING ? formattedDate(res.data[0].FIRST_LISTING) :"";
          data['FIRST_CLOSING'] =  res.data[0].FIRST_CLOSING ? formattedDate(res.data[0].FIRST_CLOSING) :"";
          data['TERMINATION_DATE'] =  res.data[0].TERMINATION_DATE ? formattedDate(res.data[0].TERMINATION_DATE) :"";
          
          // Preserve calculated fields
          if (res.data[0].YRS_AT_STRIVE) data['YRS_AT_STRIVE'] = res.data[0].YRS_AT_STRIVE;
          if (res.data[0].AGE) data['AGE'] = res.data[0].AGE;
          
          // Preserve PHOTO field if it exists in state (may not be in response)
          if (this.state.data.PHOTO) {
            data['PHOTO'] = this.state.data.PHOTO;
          } else if (res.data[0].PHOTO) {
            data['PHOTO'] = res.data[0].PHOTO;
          }

          let { MARKET,TYPE,TERRITORY } = this.state.data;
          let notFoundMessage = null;
          /* 
          INFO:
          Checking weather we have records on master table with the given combination market producttype and territory
          */
          let territoryMapingData = [];
          let agentId = res.data[0].ARCIMEDES_ROW_ID
          if((!this.state.original) || (this.state.original.MARKET !== MARKET) || (this.state.original.TYPE !== TYPE) || (this.state.original.TERRITORY !== TERRITORY)){
            let newKeys = [];
            TERRITORY = TERRITORY && TERRITORY.replace(/^,|,$/g, '');
            TYPE = TYPE && TYPE.replace(/^,|,$/g, '');
            MARKET = MARKET && MARKET.replace(/^,|,$/g, '');
            TERRITORY && TERRITORY.split(',').forEach(_territory => {
              TYPE.split(',').forEach(type => {
                MARKET.split(',').forEach(market => {
                  let key = market+'#'+type+'#'+_territory;
                  key = key.replaceAll(',','')
                  newKeys.push(key);
                  if(key in this.state.territoryMasterData){
                    if(!(key in this.state.territoryCombinations)){
                      Object.keys(this.state.territoryMasterData[key]).forEach((ARCIMEDES_ROW_ID)=>{
                        territoryMapingData.push({
                          TERRITORY_ID: ARCIMEDES_ROW_ID,
                          AGENT_ID: agentId
                        })
                      })
                    }
                  }else{
                    notFoundMessage = key.replaceAll("#", ", ")
                  }
                })
              })
            })
            let shouldDeleteRows = [];
            // deleting the rows which are unselected
            Object.keys(this.state.territoryCombinations).forEach((key)=>{
              if(!(newKeys.includes(key))){
                shouldDeleteRows = [...shouldDeleteRows, ...this.state.territoryCombinations[key]]
              }
            })
            shouldDeleteRows.forEach(ARCIMEDES_ROW_ID => {
              territoryMapingData.push({
                ARCIMEDES_ROW_ID,
                DELETED:1
              })
            });
            // updating the records in agent mapping creating/deleting
            if(territoryMapingData){
              manageData({ tableCode: TERRITORY_AGENT_MAPING, data: territoryMapingData}).then((res) => {
                if(!this.props.edit){
                  browserHistory.push({
                    pathname: `/teamMember/${agentId}`,
                  });
                }
                this.fetchTerritory(data)
              });
            }
          }
            
          if(notFoundMessage){
            this.setState({
              isBusy: null,
              error: `Master data not found with given combination ${notFoundMessage.replaceAll(', ,',"")}.`,
            });
          }else{
          // Check if FIRST_NAME or PHOTO changed - if so, clear celebration card cache
          const original = this.state.original || {};
          const nameChanged = original.FIRST_NAME !== data.FIRST_NAME;
          const photoChanged = original.PHOTO !== data.PHOTO;
          
          if ((nameChanged || photoChanged) && res.data[0].ARCIMEDES_ROW_ID) {
            console.log('[TEAM-MEMBER] Name or photo changed, clearing celebration card cache...');
            this.clearCelebrationCardsCache(res.data[0].ARCIMEDES_ROW_ID).catch(err => {
              console.error('[TEAM-MEMBER] Failed to clear celebration cards cache:', err);
              // Don't block the save - cache clearing is non-critical
            });
          }
          
          this.setState(
            {
              data:data,
              isBusy: false,
              success: "Saved"              
            },
            () => {
              if (!this.props.edit && !territoryMapingData) {
                browserHistory.push({
                  pathname: `/teamMember/${res.data[0].ARCIMEDES_ROW_ID}`,
                });
              }
            }
          );
        }

          window.scrollTo(0, 0);
        } else {
          this.setState({
            isBusy: null,
            error: res && res.message ? res.message : "Unspecified error",
          });
        }
      }
    );
  }

 

  toggleDrawer() {
    this.setState((prevState) => ({ showDrawer: !prevState.showDrawer, resetDrawer:false }));
  }

  addNewItem(addNewItemType) {
    this.setState({ addNewItemType }, this.toggleDrawer);
  }

  addNewTerritory(){
    let newTerritoryField = {
        PRODUCT_TYPE_ID: "",
        MARKET_ID: "",
        TERRITORY_ID: "",
        _cid: `new-${Date.now()}-${Math.round(Math.random() * 1e6)}`
      }
    this.setState((prevState) => ({territories: [...prevState.territories, newTerritoryField]}));
  }

  // Discard unsaved territory rows (added or edited) when the user cancels the edit.
  cancelTerritories(){
    this.setState((prevState) => ({ territories: (prevState.originalTerritories || []).map(t => ({ ...t })) }));
  }

  /** What the signed-in member may do on this page (access-levels.js). */
  getTabAccess() {
    const data = this.state.data;
    return getTeamMemberTabAccess(
      getCurrentAccess(),
      data && data.EMAIL,
      this.props.params.id === undefined,
    );
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;
    const access = getCurrentAccess();
    const tabAccess = this.getTabAccess();
    // Helper function to check if user should see Territory tab
    const shouldShowTerritoryTab = (role) => {
      return role === 'a' || role === 'y'; // Summit Agent (a) or old agent code (y)
    };

    // Build tabs array conditionally
    const tabs = [
      {
        name: "TEAM MEMBER",
        renderedComponent: (
          <TeamMemberInfo
            data={data}
            offices={this.state.offices}
            isExists={this.state.isExists}
            handleChangeInput={this.handleChangeInput}
            handleChangeDropdown={this.handleChangeDropdown}
            handleChangeFile={this.handleChangeFile}
            viewMode={tabAccess.info === 'view' ? true : this.state.viewMode}
            accountFieldsViewOnly={tabAccess.accountFields !== 'edit'}
            deleted={data && data.DELETED === "1"}
            addNewItem={this.addNewItem}
          />
        ),
      }
    ];
    const territoriesViewMode = tabAccess.territories === 'view' ? true : this.state.viewMode;
    
    // Only add Territory tab for Summit - Agent
    if (data && shouldShowTerritoryTab(data.IS_AGENT)) {
      tabs.push({
        name: "TERRITORY",
        renderedComponent: (
          <div>
            <div>
              {this.state.territories.map((territory, index) => {
                  return(
                    <TeamMemberTerritoriesInfo
                      key={territory.ARCIMEDES_ROW_ID || territory._cid || `t-${index}`}
                      index={index}
                      state={this.state}
                      setState={this.setState.bind(this)}
                      territories={this.state.territories}
                      territory={territory}
                      viewMode={territoriesViewMode}
                  />
                  )
              })}
            </div>
            {territoriesViewMode == "" && <button type="button" className="add-territory-btn" onClick={this.addNewTerritory}>
              Add Territory
            </button>}
          </div>
        ),
      });
    }
    
    // FORMS and Account Settings hold personal / credential data. Who sees
    // them is decided by the viewer's access level; without one, only the
    // member themselves plus David McNeil, Jason Vitorino and Anna Rosowski
    // (Claritask 547010). Creating a new member is exempt — the Account
    // Settings tab is where the username and password are set.
    if (tabAccess.forms) {
      tabs.push({
        name: "FORMS",
        renderedComponent: (
          <TeamMemberUploadDocInfo
            data={data}
            isDisabled={this.state.isDisabled}
            isExists={this.state.isExists}
            handleChangeInput={this.handleChangeInput}
            handleChangeFile={this.handleChangeFile}
            viewMode={this.state.viewMode}
            deleted={data && data.DELETED === "1"}
            addNewItem={this.addNewItem}
            onUploadingChange={(isUploading) => this.setState({ fileUploadInProgress: isUploading })}
          />
        ),
      });
    }

    if (tabAccess.accountSettings) {
      // Add Account Settings tab last
      tabs.push({
        name: "Account Settings",
        renderedComponent: (
          <TeamMemberAccountTab
            data={data}
            viewMode={this.state.viewMode}
            canEdit={tabAccess.accountSettings === 'edit'}
            canAssignAccessLevel={access.assignAccessLevel}
            handleChangeInput={this.handleChangeInput}
            handleChangeDropdown={this.handleChangeDropdown}
            onRefresh={this.refreshData}
          />
        ),
      });
    }

    return (
      <CRUD
        tabsData={tabs}
        backLink={`${arc.path.base}teamMembers`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={this.saveData}
        onCancel={this.cancelTerritories}
        type="Team Member"
        backName={can('team.list') ? "TEAM MEMBERS" : null}
        title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
        /* Edit and Save whenever some tab here is the viewer's to change —
           a Senior Agent's own Forms included. */
        forceActions={tabAccess.info === 'edit' || tabAccess.territories === 'edit'
          || tabAccess.accountSettings === 'edit' || tabAccess.forms}
        /* A Founder's or an Admin's account is the Founder's to delete, deactivate or reactivate. */
        hideDelete={!can('team.accounts', 'edit')
          || isFounderOnlyAccount(getCurrentAccess(), this.state.accessLevelOptions, data && data.ACCESS_LEVEL, data && data.ARCIMEDES_ROW_ID)}
        drawer={
          <Drawer
            isOpen={this.state.showDrawer}
            shouldDisplayChildDrawer={true}
            reff={this.drawerComponentRef}
            closeDrawer={this.closeDrawer}
          >
           
          </Drawer>
        }
      />
    );
  }
}
